__turbopack_context__.v({
  "attribution": "article-card-module-scss-module__bDAotG__attribution",
  "comingSoon": "article-card-module-scss-module__bDAotG__comingSoon",
});
